import React, { useState, useEffect, useRef, useMemo } from "react";

// SERVICES
import APIRequests from "~/services/requests_api";
import AuthService from "~/services/auth";

// COMPONENTES GERAIS
import SearchInput from "~/components/SearchInput";

// BOOTSTRAP
import Row from "~/components/Bootstrap/Row";
import { ColSm3, ColSm9 } from "~/components/Bootstrap/Col";

// COMPONENTES DE BASEPAGE
import { BasePageMain, BasePageContainer, BasePageBox, BasePageTitleContainer, BasePageTitle, BasePageButtonsContainer, BasePageTopLineSeparator } from "~/components/BasePage";

// TABLE
import { Table, Thead, Tbody, Tr, Th, Td } from '~/components/Table';

// COMPONENTES GERAIS
import NavigationBar from "~/components/NavigationBar";
import ButtonPrimary from '~/components/Buttons/Small/Primary';

// COMPONENTES INTERNOS
import ModalCadastroEdicao from "./components/ModalCadEdit";

// UTILS
import Utils from "~/utils";

export default function PageCadastroAdministradores() {

    const RefModalCad = useRef(null);

    /**
     * Lista de Administradores
     */
    const [Administradores, setAdministradores] = useState([]);

    const [Pesquisa, setPesquisa] = useState('');
    const [Pesquisar, setPesquisar] = useState(false);

    /**
     * Carrega os Administradores da
     */
    const goLoadAdministradores = async () => {
        const Administradores = await APIRequests.administradores.listar(Pesquisa);

        if (Administradores.results) {
            setAdministradores(Administradores.results);
        }
    }

    /**
     * Abre o modal para inserir.
     */
    const onRequestAddAdministrador = () => {
        RefModalCad?.current?.open();
    }

    /**
     * Abre o modal para editar.
     */
    const onRequestEditAdministrador = (uuid) => {
        RefModalCad?.current?.open(uuid);
    }

    /**
     * Ao confirmar o cadastro ou edição do Administrador.
     */
    const onConfirmCadEditAdministrador = () => {
        goLoadAdministradores();
    }

    /**
     * Carrega os Administradores a cada pesquisa
     */
    useEffect(() => {
        if (Pesquisar === true) {
            goLoadAdministradores();
        }
    }, [Pesquisa, Pesquisar]);

    /**
     * Carrega a listagem de usuários quando carregar a página.
     */
    useEffect(() => {
        goLoadAdministradores();
    }, []);

    return (
        <BasePageMain id="main">
            <NavigationBar />

            <BasePageContainer id="container">

                <BasePageTitleContainer>
                    <BasePageTitle>
                        Cadastro de Administradores
                    </BasePageTitle>
                </BasePageTitleContainer>

                <BasePageTopLineSeparator />

                <BasePageButtonsContainer>
                    {AuthService.checkPermission('administradores', 'adicionar') && (
                        <ButtonPrimary onClick={onRequestAddAdministrador}>
                            Adicionar
                        </ButtonPrimary>
                    )}

                </BasePageButtonsContainer>

                <BasePageBox id="box">
                    <Row>
                        <ColSm9 />
                        <ColSm3>
                            <SearchInput
                                inputType="small"
                                onChange={(e) => setPesquisar(true)}
                                onSearch={(text) => setPesquisa(text)}
                            />
                        </ColSm3>
                    </Row>

                    <div style={{ marginTop: 10 }}>
                        <Table nostriped>
                            <Thead>
                                <Tr>
                                    <Th width={100}>
                                        <center>#</center>
                                    </Th>
                                    <Th>Nome</Th>
                                    <Th width={220}>E-mail</Th>
                                    <Th width={115}>Celular</Th>
                                    <Th width={100}>Situação</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {Administradores.map((prod) => {
                                    return (
                                        <Tr key={prod.uuid}>
                                            <Td width={100}>
                                                <center>
                                                    {AuthService.checkPermission('administradores', 'editar') ? (
                                                        <ButtonPrimary onClick={() => onRequestEditAdministrador(prod.uuid)}>
                                                            <i className="fas fa-pencil" />
                                                        </ButtonPrimary>
                                                    ) : (
                                                        <ButtonPrimary disabled="disabled" onClick={() => onRequestEditAdministrador(prod.uuid)}>
                                                            <i className="fas fa-pencil" />
                                                        </ButtonPrimary>
                                                    )}
                                                </center>
                                            </Td>
                                            <Td>{prod.nome}</Td>
                                            <Td width={220}>{prod.email}</Td>
                                            <Td width={115}>{prod.celular}</Td>
                                            <Td width={100} style={{ textTransform: 'capitalize' }}>{prod.situacao}</Td>
                                        </Tr>
                                    )
                                })}
                            </Tbody>
                        </Table>
                    </div>
                </BasePageBox>
            </BasePageContainer>

            <ModalCadastroEdicao
                ref={RefModalCad}
                onConfirmCadEdit={onConfirmCadEditAdministrador}
            />

        </BasePageMain >
    );
}
